
import {isEmpty} from 'lodash-es'

const validatorsTextDefault = Object.freeze({
  require: '必須です',
  email:   '無効なメールアドレスです',
  tel:     '無効な電話番号です',
  post:    '無効な郵便番号です',
})

let validatorsText

const validatorsDefault = Object.freeze({
  require(value) {
    if(isEmpty(value)) {
      return validatorsText.require
    }
  },

  email(value) {
    // 参考: https://emailregex.com/
    if(!isEmpty(value) && !value.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
      return validatorsText.email
    }
  },

  tel(value) {
    // 参考: http://akinov.hatenablog.com/entry/2017/05/31/194421
    if(!isEmpty(value) && !(
      // 固定電話番号
      value.match(/^0([1-9]-?\d{4}|[1-9]\d-?\d{3}|[1-9]\d{2}-?\d{2}|[1-9]\d{3}-?\d)-?\d{4}$/) ||
      // 携帯電話番号
      value.match(/^0[5789]0-?\d{4}-?\d{4}$/)
    )) {
      return validatorsText.tel
    }
  },

  post(value) {
    if(!isEmpty(value) && !value.match(/^\d{3}-?\d{4}$/)) {
      return validatorsText.post
    }
  },
})

export let validators

export default {
  install(Vue, options) {
    const validatorsTextApply = customs => {
      validatorsText = Object.freeze({
        ...validatorsTextDefault,
        ...customs,
        apply: validatorsTextApply,
      })
      Vue.prototype.$cnmn = {...Vue.prototype.$cnmn, validatorsText}
      Vue.cnmn = {...Vue.cnmn, validatorsText}
    }
    validatorsTextApply()

    const validatorsApply = customs => {
      validators = Object.freeze({
        ...validatorsDefault,
        ...customs,
        apply: validatorsApply,
      })
      Vue.prototype.$cnmn = {...Vue.prototype.$cnmn, validators}
      Vue.cnmn = {...Vue.cnmn, validators}
    }
    validatorsApply()
  }
}
